module.exports = __webpack_public_path__ + "static/media/testimonial-image-02.aa5805a4.png";